
(function () {
    'use strict';

    angular.module('customeDirectivesModule')
           .directive('npCollapseLeft', npCollapse);

    function npCollapse() {
        var directive = {
            restrict: 'EA',
            replace: true,
            template: '<span class="group-collapse-arrow pointer" ng-click="vm.collapsed()"></span>',
            scope: {
                collapseTarget: '@',
                onCollapsed: '&'
            },
            link: linkFunction,
            controller: ['$scope', controller],
            controllerAs: 'vm'
        };

        return directive;

        function linkFunction(scope, el, attr, ctrl) {

        };

        function controller($scope) {
            var vm = this;
            vm.collapsedFlag = false;
            vm.collapsed = collapsed;

            function collapsed() {
                vm.collapsedFlag = !vm.collapsedFlag;
                angular.element('#' + $scope.collapseTarget).toggleClass('collapsed');
                angular.element('#' + $scope.collapseTarget + '_icon').toggleClass('group-collapsed-arrow').toggleClass('group-collapse-arrow');
                $scope.onCollapsed({ collapsedFlag: vm.collapsedFlag });
            };
        };
    };

})();